import { createSelector } from 'reselect';

import { getEntityShortId } from '@neptune/shared/entity-domain';
import { makeEntityIdentifier } from '@neptune/shared/entity-util';
import { getCurrentRouteParams } from '@neptune/shared/routing-business-logic';

import { getRunIdentificationKeyFromAttributes } from 'domain/experiment/attribute';

import { CurrentEntityState } from './reducer';

const getCurrentEntityState = (state: any): CurrentEntityState => state.currentEntity;

const getCurrentBasicEntityInternal = (state: any) =>
  getCurrentEntityState(state).basicEntity.entity;

export const getCurrentBasicEntityFetchStatus = createSelector(
  getCurrentEntityState,
  (state: CurrentEntityState) => state.basicEntity.fetchStatus,
);

export const getCurrentBasicEntityFetchError = createSelector(
  getCurrentEntityState,
  (state: CurrentEntityState) => state.basicEntity.error,
);

export const getCurrentBasicEntity = createSelector(
  [getCurrentBasicEntityInternal, getCurrentRouteParams],
  (entity, params) => {
    if (
      !entity ||
      !params.organizationName ||
      !params.projectName ||
      !params.runIdentificationKey
    ) {
      return undefined;
    }

    let runIdentificationKey = getEntityShortId(entity);

    if (params.type === 'experiment') {
      runIdentificationKey = getRunIdentificationKeyFromAttributes(entity.attributes) ?? '';
    }

    const experimentIdentifier = makeEntityIdentifier(
      entity.organizationName,
      entity.projectName,
      runIdentificationKey ?? '',
    );

    const expectedEntityId = makeEntityIdentifier(
      params.organizationName,
      params.projectName,
      params.runIdentificationKey,
    );

    if (experimentIdentifier !== expectedEntityId) {
      return undefined;
    }

    return entity;
  },
);

export const getCurrentEntityShortId = createSelector(getCurrentBasicEntity, (entity) => {
  if (!entity) {
    return undefined;
  }

  return getEntityShortId(entity);
});

export const getCurrentEntityId = createSelector(getCurrentBasicEntity, (entity) => {
  return entity?.id;
});
